import React from "react";

const SimpleTableComponent = (props) => {

  const createListingData = () => {
    props.data.map((obj) => {
      return <tr>
        {Object.keys(obj).map((key) => {
          return <td>{obj[key]}</td>
        })}
      </tr>
    })
  }
  const total_rows = props.data.length;

  const beautifyString = (hash) => {
    return hash.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  }

  return (
    <>
      <div style={{ textTransform: "capitalize" }} className="fw-medium p-2 text-success"><u>{props.heading}</u></div>
      <table className="table table-bordered">
        <thead className="bg-active">
          <tr>
            {props.data[0] && Object.keys(props.data[0]).map((heading) => {
              return <th key={`simple_heading${heading}`}>{beautifyString(heading)}</th>
            })}
          </tr>
        </thead>
        <tbody>
          {props.data && props.data.map((obj, index) => {
            return <tr key={`simple_data${index}`} className="border">
              {Object.keys(obj).map((key) => {
                if (obj[key] !== null) {
                  return <td key={`simple_td_${key}`} className="border ps-2">{obj[key]}</td>
                } else {
                  return <td key={`simple_td_blank${key}`} className="border ps-2">-</td>
                }
              })}
            </tr>
          })}
        </tbody>
      </table>
    </>
  )
};

export default SimpleTableComponent;
